import React from "react";
import './styles.css';



  


function Navhovstory(){

    return (
        <>
            <li>
                <span className="link">
                    <span className="word">
                        <span className="char" data-char="w" style={{"--charIndex": 0 }}>w</span>
                        <span className="char" data-char="e" style={{"--charIndex": 1 }}>e</span>
                        <span className="char" data-char="b" style={{"--charIndex": 2 }}>b</span>
                        <span className="char" data-char="c" style={{"--charIndex": 3 }}>c</span>
                        <span className="char" data-char="o" style={{"--charIndex": 4 }}>o</span>
                        <span className="char" data-char="m" style={{"--charIndex": 5 }}>m</span>
                        <span className="char" data-char="i" style={{"--charIndex": 6 }}>i</span>
                        <span className="char" data-char="c" style={{"--charIndex": 6 }}>c</span>
                    </span>
                </span>
                    
            </li>
        </>
        
    )
}

export default Navhovstory;